import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Hermes } from '@kaligo/hermes';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';
import { ButtonTheme } from '@rd/types';
import { LogoutUser } from '../../auth/store/actions/auth.actions';
import { CoreState } from '../../store/reducers';

@Component({
  selector: 'rd-core-auth-user-idle-dialog',
  templateUrl: './auth-user-idle-dialog.component.html',
  styleUrls: ['./auth-user-idle-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AuthUserIdleDialogComponent implements OnInit, OnDestroy {
  @HostBinding('class.rd-core-auth-user-idle-dialog') componentClass = true;

  remainingSeconds: number | undefined;

  timeUpdateInterval: any;

  constructor(
    private dialogRef: DialogRef,
    private store: Store<{ core: CoreState }>,
    private translateService: TranslateService,
    private cdRef: ChangeDetectorRef,
    private dialogConfig: DialogConfig<{ hermes: Hermes }>,
    private popupSettingService: PopupSettingService,
  ) {}

  close(): void {
    this.stopRemainingSecondsTextUpdate();
    this.dialogConfig?.data?.hermes.onIdleDialogClosed();
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.remainingSeconds =
      this.dialogConfig?.data?.hermes.getIdleDialogRemainingSeconds();
    this.timeUpdateInterval = setInterval(
      () => this.updateRemainingSecondsText(),
      1000,
    );
  }

  ngOnDestroy(): void {
    this.stopRemainingSecondsTextUpdate();
  }

  updateRemainingSecondsText(): void {
    this.remainingSeconds =
      this.dialogConfig?.data?.hermes.getIdleDialogRemainingSeconds();

    if (this.remainingSeconds !== undefined && this.remainingSeconds <= 0) {
      this.remainingSeconds = 0;
      this.stopRemainingSecondsTextUpdate();
      this.logout();
    }

    this.cdRef.markForCheck();
  }

  logout(): void {
    this.store.dispatch(new LogoutUser());
  }

  stopRemainingSecondsTextUpdate(): void {
    if (this.timeUpdateInterval) {
      clearInterval(this.timeUpdateInterval);
      this.timeUpdateInterval = null;
    }
  }

  remainingSecondsText(): string {
    if (this.remainingSeconds === undefined || this.remainingSeconds <= 0) {
      return this.translateService.instant('auth.logged_out_time', {
        seconds: 0,
      });
    }

    return this.translateService.instant('auth.logged_out_time', {
      seconds: this.remainingSeconds,
    });
  }

  get buttonTheme(): ButtonTheme {
    return this.popupSettingService.userIdleDialogButtonTheme;
  }
}
